import type { Partner } from '@pulsify/shared/dto'
import { Copy, QrCode } from 'lucide-react'
import { toast } from 'sonner'
import * as m from '~/paraglide/messages'
import { copyToClipboard } from '~/shared/lib/share'
import { Button } from '~/shared/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '~/shared/ui/dialog'
import { QrDownload } from '~/shared/ui/qr-download'

export function partnerKindLabel(kind: Partner['kind']): string {
  return kind === 'person' ? m.partnersKindPerson() : m.partnersKindOrganisation()
}

/** The partner link with buttons to copy it and to show it as a QR code. */
export function PartnerLink({ partner }: { partner: Partner }) {
  const copy = async () => {
    if (await copyToClipboard(partner.url)) toast.success(m.linkCopied())
    else toast.error(m.failedToCopyLink())
  }

  return (
    <div className="flex items-center gap-1">
      <span className="font-mono text-xs whitespace-nowrap">{partner.url}</span>
      <Button
        variant="ghost"
        size="sm"
        className="h-7 px-1.5"
        onClick={copy}
        aria-label={m.partnersCopyLink()}
        title={m.partnersCopyLink()}
      >
        <Copy className="h-3.5 w-3.5" />
      </Button>
      <Dialog>
        <DialogTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            className="h-7 px-1.5"
            aria-label={m.partnersShowQr()}
            title={m.partnersShowQr()}
          >
            <QrCode className="h-3.5 w-3.5" />
          </Button>
        </DialogTrigger>
        <DialogContent className="sm:max-w-sm">
          <DialogHeader>
            <DialogTitle>{partner.name}</DialogTitle>
            <DialogDescription className="break-all font-mono text-xs">
              {partner.url}
            </DialogDescription>
          </DialogHeader>
          <QrDownload
            value={partner.url}
            title={m.partnersQrAlt({ name: partner.name })}
            fileName={`pulsify-partner-${partner.code}`}
            downloadLabel={m.partnersDownloadPng()}
          />
        </DialogContent>
      </Dialog>
    </div>
  )
}
